import { createContext } from 'react';

const ProgressContext = createContext();

export default ProgressContext;